// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  appName: 'WebDilIngresoFormSimple2593',
  release: '20240506-053036',
  production: false
};



// WEBPACK FOOTER //
// D:/GIT/Simple2593V5/Ingreso/ng_ingresosimple2593/src/environments/environment.ts